import { v4 as uuidV4 } from 'uuid';

export function useEndUsersHeaders(
  customerNumber: string,
  countryCode: string
) {
  const correlationId = uuidV4();
  const normalizedCountryCode = countryCode === 'UK' ? 'GB' : countryCode;
  return {
    'IM-CorrelationID': correlationId.slice(0, 32),
    'IM-CountryCode': normalizedCountryCode,
    'IM-CustomerNumber': `${customerNumber.slice(0, 2)}-${customerNumber.slice(
      2
    )}`,
    'IM-SenderID': 'GDS',
  };
}
